import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

declare global {
  interface Window {
    Calendly?: any;
  }
}
declare const Calendly: any;

@Component({
  selector: 'app-calendly',
  standalone: true,
  imports: [],
  templateUrl: './calendly.component.html',
  styleUrl: './calendly.component.scss',
})
export class CalendlyComponent implements OnInit, OnDestroy {
  @Input({ required: true }) url!: string; // link pubblico del profilo
  @Input() prefill?: {
    name?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    customAnswers?: Record<string, string>;
  };
  @Input() autoResize = true;
  @Output() scheduled = new EventEmitter<any>(); // payload evento successo

  private onMessage = (e: MessageEvent) => {
    if (
      (e.origin === 'https://calendly.com' ||
        e.origin === 'https://myndoor.support') &&
      e.data?.event?.startsWith('calendly.')
    ) {
      if (e.data.event === 'calendly.event_scheduled') {
        setTimeout(() => {
          this.scheduled.emit(e.data.payload);
        }, 2000);
      }
    }
  };

  containerId = 'calendly-embed-' + Math.random().toString(36).slice(2);

  constructor(private host: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.ensureScript().then(() => this.initWidget());
    window.addEventListener('message', this.onMessage);
  }

  private async ensureScript(): Promise<void> {
    // Controlla se lo script è già caricato
    if (
      document.querySelector(
        'script[src="https://assets.calendly.com/assets/external/widget.js"]'
      )
    ) {
      // Se è già caricato, aspetta che Calendly sia disponibile
      await this.waitForCalendly();
      return;
    }

    await new Promise<void>((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://assets.calendly.com/assets/external/widget.js';
      s.async = true;
      s.onload = () => {
        // Aspetta che Calendly sia completamente inizializzato
        this.waitForCalendly().then(() => resolve());
      };
      s.onerror = () => reject(new Error('Calendly script load error'));
      document.head.appendChild(s);
    });
  }

  private async waitForCalendly(): Promise<void> {
    return new Promise((resolve) => {
      const checkCalendly = () => {
        if (typeof Calendly !== 'undefined' && Calendly.initInlineWidget) {
          resolve();
        } else {
          setTimeout(checkCalendly, 100);
        }
      };
      checkCalendly();
    });
  }

  private initWidget() {
    const parentElement = document.getElementById(this.containerId)!;

    // Pulisci il container prima di inizializzare
    parentElement.innerHTML = '';

    // Inizializza il widget solo se Calendly è disponibile
    if (typeof Calendly !== 'undefined' && Calendly.initInlineWidget) {
      Calendly.initInlineWidget({
        url: this.url,
        parentElement,
        prefill: this.prefill,
        resize: this.autoResize, // ogni istanza può fare resize indipendentemente
      });
    }
  }

  private destroyWidget() {
    const parentElement = document.getElementById(this.containerId);
    if (parentElement) {
      parentElement.innerHTML = '';
    }
  }

  ngOnDestroy(): void {
    this.destroyWidget();
    window.removeEventListener('message', this.onMessage);
  }
}
